// Exchange rate types for ARS currency (backend values)
export const EXCHANGE_RATE_TYPES = {
  BLUE: 'BLUE',
  CRIPTO: 'CRYPTO', // Backend receives 'CRYPTO'
  CUSTOM: 'CUSTOM'
} as const;

export type ExchangeRateType = typeof EXCHANGE_RATE_TYPES[keyof typeof EXCHANGE_RATE_TYPES];
